import { Image } from "antd";
import axios from "axios";
import { create } from "zustand";
import { MAIN_URL } from "../../Constants";

export let useSlider = create((set, get) => ({
    slider: [],
    ed: [],
    setEd: (ed) => set({ ed }),
    getSlider: () => {
        axios.get('sliders').then(res => {
            set({ slider: res.data })
        })
    },
    addSlider: (slider) => {
        axios.post('sliders', slider).then(res => {
            get().getSlider()
        })
    },
    deleteSlider: (slider) => {
        axios.delete(`sliders/${slider.id}`).then(res => {
            get().getSlider()
        })
    },
    updateSlider: (slider) => {
        axios.put(`sliders/${slider.id}`, slider).then(res => {
            get().getSlider()
        })
    },
    
    columns: [
        {
            title: 'ID',
            dataIndex: 'id',
            key: 'id',
            width: 100
        },
        {
            title: 'Rasm',
            dataIndex: 'img',
            key: 'img',
            width: 150,
            render: (_, rec) => <Image width={100} height={100} style={{ objectFit: 'cover' }} src={MAIN_URL + '/' + rec.img} alt="" />
        },
        {
            title: 'Sarlavha',
            dataIndex: 'titleuz',
            key: 'titleuz',
            render: (_, rec) => <span>{rec.titleuz} <br /> {rec.titleru}</span>
        },
        {
            title: 'Tugma matni',
            dataIndex: 'btntextuz',
            key: 'btntextuz',
            render: (_, rec) => <span>{rec.btntextuz} <br /> {rec.btntextru}</span>
        },  
        {
            title: 'Tugma URL',
            dataIndex: 'btnurl',
            key: 'btnurl',
        },
        {
            title: 'Qo`shimcha matn',
            dataIndex: 'subtitleuz',
            key: 'subtitleuz',
            render: (_, rec) => <span>{rec.subtitleuz} <br /> {rec.subtitleru}</span>
        },

    ]
}))